<template>
    <section id="contact"
             class="w-full max-h-screen h-screen snap-start space-y-12 bg-gray-900 carousel-wrapper flex flex-col justify-center items-center">

        <h6 class="text-3xl md:text-5xl text-purple-600">Contactez-moi!</h6>
        <div class="container bg-gray-700">
            <form ref="form" class="text-black" @submit.prevent="sendEmail">
                <label class="text-purple-300">Name</label>
                <input
                        type="text"
                        v-model="name"
                        name="name"
                        placeholder="Votre nom"
                        minlength="3"
                        required
                >
                <label class="text-purple-300">Email</label>
                <input
                        type="email"
                        v-model="email"
                        name="email"
                        placeholder="Votre Email"
                        minlength="6"
                        required
                >
                <label class="text-purple-300">Sujet</label>
                <input
                        type="text"
                        v-model="subject"
                        name="subject"
                        placeholder="Votre sujet"
                        minlength="3"
                        required
                >
                <label class="text-purple-300">Message</label>
                <textarea
                        name="message"
                        v-model="message"
                        cols="30" rows="5"
                        placeholder="Message"
                        minlength="3"
                        required>
          </textarea>

                <input type="submit" value="Send" class=" hover:bg-purple-800 duration-1000 ">
            </form>
        </div>

    </section>
</template>

<script>
    import emailjs from 'emailjs-com';


    export default {
        methods: {
            sendEmail() {
                emailjs.sendForm('service_kjo60i8', 'template_hwluanp', this.$refs.form, 'user_k5x3jLIIADrUmTmX7y4Nh')
                    .then((result) => {
                        this.$swal('Votre message a bien été envoyé!',result);
                    }, (error) => {
                        this.$swal("Nous sommes désolé, votre message n'a pas pu être envoyé...",error);
                    });
            }
        }
    }
</script>

<style scoped>
    * {box-sizing: border-box;}

    .container {
        display: block;
        margin:auto;
        text-align: center;
        border-radius: 5px;
        padding: 20px;
        width: 50%;
    }

    label {
        float: left;
    }

    input[type=text], [type=email], textarea {
        width: 100%;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 6px;
        margin-bottom: 16px;
        resize: vertical;
    }

    input[type=submit] {
        color: black;
        padding: 12px 20px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }

    input[type=submit]:hover {
        color: white;
    }
</style>